/**
 * API配置工具
 * 根据环境自动设置API基础URL
 * 
 * 注意：此函数必须在浏览器运行时调用，不能在构建时调用
 */

/**
 * 获取API基础URL
 * - 开发环境：使用 localhost:5001
 * - 生产环境：使用相对路径（空字符串），自动适配当前域名
 */
export const getApiBaseUrl = () => {
  // 检查是否在浏览器环境中
  if (typeof window === 'undefined' || !window.location) {
    // 服务端渲染或构建时，返回空字符串（相对路径）
    return '';
  }

  // 运行时判断：根据当前访问的域名判断环境
  try {
    const location = window.location;
    const hostname = location.hostname;
    
    // 开发环境：localhost 或 127.0.0.1 - 强制使用 localhost:5001
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0') {
      console.log('🔧 开发环境检测：使用 localhost:5001');
      return 'http://localhost:5001';
    }
    
    // 生产环境：使用相对路径（空字符串），自动适配当前域名和端口
    // 如果当前访问的是 http://47.106.212.24:5001，则API请求也会使用相同的域名和端口
    return '';
  } catch (e) {
    // 如果无法获取 hostname，检查环境变量
    const envApiUrl = process.env.REACT_APP_API_URL;
    
    // 开发环境强制使用 localhost
    if (process.env.NODE_ENV === 'development') {
      console.warn('⚠️ 无法获取 hostname，开发环境强制使用 localhost:5001', e);
      return 'http://localhost:5001';
    }
    
    // 生产环境：使用环境变量或相对路径
    if (envApiUrl !== undefined && envApiUrl !== null && envApiUrl !== '') {
      return envApiUrl;
    }
    
    return '';
  }
};

// 不导出静态值，每次都动态获取
// export const API_BASE_URL = getApiBaseUrl(); // 移除这行，避免构建时硬编码

